export default {
  defaultStyle: {
    height: 'auto',
    verticalAlign: 'middle',
    fontStyle: 'normal'
  },
  gold: {
    color: data => data.mainColor
  },
  mainColor: {
    color: data => data.mainColor
  },
  mainColorSvg: {
    fill: data => data.mainColor
  },
  size32: {
    fontSize: '32px'
  },
  size20: {
    fontSize: '20px'
  },
  size22: {
    fontSize: '22px'
  },
  size24: {
    fontSize: '24px'
  },
  size25: {
    fontSize: '25px'
  },
  size17: {
    fontSize: '17px'
  },
  size18: {
    fontSize: '18px'
  },
  size15: {
    fontSize: '15px'
  },
  size14: {
    fontSize: '14px'
  },
  size13: {
    fontSize: '13px'
  },
  size12: {
    fontSize: '12px'
  },
  size11: {
    fontSize: '11px'
  },
  iconSize30: {
    width: '30px'
  },
  iconSize28: {
    width: '28px'
  },
  marginLeft14: {
    marginLeft: '14px',
    '&:lang(ar)': {
      marginRight: '14px',
      marginLeft: '0',
      display: 'inline-block',
      transform: 'rotate(180deg)'
    }
  },
  marginRight5: {
    marginRight: '5px',
  },
  penIcon: {
    marginRight: '5px',
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    }
  },
  marginRight15: {
    marginRight: '15px',
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '15px'
    }
  },
  absoluteArrow: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    marginTop: '-5px',
    '&:lang(ar)': {
      right: 'auto',
      left: '10px'
    }
  },

  marginLeft5: {
    marginLeft: '5px',
    '&:lang(ar)': {
      marginRight: '5px',
      marginLeft: '0',
      display: 'inline-block',
      transform: 'rotate(180deg)',
    }
  },
  absoluteButton: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    marginTop: '-5px',
    '&:lang(ar)': {
      right: 'auto',
      left: '10px',
    }
  },
  iconFlag: {
    position: 'absolute',
    left: '5px',
    marginRight: '5px',
    height: '15px',
    width: '16px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    backgroundSize: 'contain',
    '&:lang(ar)': {
      left: 'auto',
      right: '5px',
      marginRight: '0',
      marginLeft: '5px'
    }
  },
  adultIcon: {
    fontSize: '15px',
    marginRight: '5px',
    display: 'inline-block',
    lineHeight: '1',
    marginTop: '-6px',
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    },
    '@media (min-width: 801px)': {
      fontSize: '20px',
      marginRight: '7px',
      verticalAlign: 'middle',
      '&:lang(ar)': {
        marginRight: '0',
        marginLeft: '7px'
      }
    }
  },
  childIcon: {
    fontSize: '11px',
    position: 'relative',
    marginLeft: '5px',
    paddingLeft: '15px',
    marginRight: '5px',
    '&::after': {
      content: "'|'",
      position: 'absolute',
      left: '0',
      top: '50%',
      lineHeight: '0',
      fontSize: '14px',
      color: '#000',
      fontFamily:data=>data.fontFamily1
    },
    '&:lang(ar)': {
      paddingLeft: '0',
      paddingRight: '15px',
      '&::after': {
        left: 'auto',
        right: '0'
      }
    },
    '@media (min-width: 801px)': {
      fontSize: '15px',
      marginRight: '7px',
      paddingLeft: '10px',
      verticalAlign: 'middle',
      '&::after': {
        fontSize: '21px'
      },
      '&:lang(ar)': {
        marginRight: '0',
        marginLeft: '7px',
        paddingLeft: '0',
        paddingRight: '10px'
      }
    }
  },
  deleteIcon: {
    fontSize: '15px',
    '@media (min-width: 801px)': {
      fontSize: '25px'
    }
  },
  editIcon: {
    fontSize: '15px',
    '@media (min-width: 801px)': {
      fontSize: '25px'
    }
  },
  iconTab: {
    verticalAlign: 'bottom',
    marginRight: '5px',
    '&:lang(ar)': {
      marginRight: '0',
      marginLeft: '5px'
    }
  }
};
